import {ApplicationVO, ApplicationListVO} from './application.interfaces';
import {All} from './application.actions';
import {CrudAll, crudInitialState, CrudReducer, CrudState, createCrudDefinition} from '@abydos-angular/store';

export interface ApplicationState extends CrudState<ApplicationVO> {
}

export const initialState: ApplicationState = {
    ...crudInitialState
};

export const applicationFeatureName = 'application';

export const applicationDefinition = createCrudDefinition<ApplicationVO, ApplicationListVO>(applicationFeatureName , initialState);
/*
Ez egy minta sub definíció, ha a modulban 1-nél több CRUD-ra van szükség
export const applicationSubDefinition = createCrudDefinition<ApplicationSubVO, ApplicationSubListVO>(applicationDefinition, crudInitialState, 'applicationSub');
 */

export function applicationReducer<T, S>(state: ApplicationState, action: All): ApplicationState {
    switch (action.type) {
        default: {
            return CrudReducer(applicationDefinition, state, action as CrudAll<T, S>) as ApplicationState;
        }
    }
}
